module.exports = __webpack_public_path__ + "static/media/wausd_crv.9e32267a.png";